import { useState } from "react";
import api from "./api";

/**
 * Hook that returns: { pinLoading, pinSuggestions, onPincodeChange }.
 * - When the pincode reaches 6 digits, it calls /api/meta/pincode/{pin}.
 * - It calls onResolved({city, state, post_offices}) so the parent can decide what to fill.
 */
export function usePincodeLookup(onResolved) {
  const [pinLoading, setPinLoading] = useState(false);
  const [pinSuggestions, setPinSuggestions] = useState([]);

  async function onPincodeChange(value, currentForm) {
    const pin = (value || "").replace(/\D/g, "").slice(0, 6);
    if (pin.length !== 6) {
      setPinSuggestions([]);
      onResolved?.({ pincode: pin });
      return;
    }
    setPinLoading(true);
    try {
      const r = await api.get(`/meta/pincode/${pin}`);
      const offices = Array.isArray(r.data.post_offices) ? r.data.post_offices : [];
      setPinSuggestions(offices);
      onResolved?.({
        pincode: pin,
        city: r.data.city || "",
        state: r.data.state || "",
        post_offices: offices,
      });
    } catch (err) {
      setPinSuggestions([]);
      onResolved?.({ pincode: pin });
    } finally {
      setPinLoading(false);
    }
  }

  return { pinLoading, pinSuggestions, onPincodeChange };
}
